<template>
  <div class="header">
    <ul>
      <router-link to="/" tag="li">
        <button>
          <font-awesome-icon
            icon="fa-solid fa-house"
            size="lg"
            color="#ddd"
            exact
          />
          <h2>Home</h2>
        </button>
      </router-link>
      <router-link to="/about" tag="li">
        <button>
          <font-awesome-icon icon="fa-solid fa-user" size="lg" color="#ddd" />
          <h2>About</h2>
        </button>
      </router-link>
      <router-link to="/portfolio" tag="li">
        <button>
          <font-awesome-icon
            icon="fa-solid fa-briefcase"
            size="lg"
            color="#ddd"
          />
          <h2>portfolio</h2>
        </button>
      </router-link>
      <router-link to="/gallery" tag="li">
        <button>
          <font-awesome-icon icon="fa-solid fa-images" size="lg" color="#ddd" />
          <h2>gallery</h2>
        </button>
      </router-link>
      <router-link to="/contact" tag="li">
        <button>
          <font-awesome-icon
            icon="fa-solid fa-envelope-open"
            size="lg"
            color="#ddd"
          />
          <h2>Contact</h2>
        </button>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HeaderPage",
};
</script>
